export const productTranslations = {
  en: {
    wordmark: "Motifect",
    tagline: "Generate production-ready 3D motion from a plain-text prompt.",
    videoLabel: "Motifect demo: text prompts to motion",
  },
  ko: {
    wordmark: "Motifect",
    tagline: "평문 텍스트 프롬프트만으로 제작 수준의 3D 모션을 생성합니다.",
    videoLabel: "Motifect 데모: 텍스트 프롬프트에서 모션으로",
  },
  zh: {
    wordmark: "Motifect",
    tagline: "用纯文本提示生成可投入制作的三维动作。",
    videoLabel: "Motifect 演示：文本提示生成动作",
  },
  ja: {
    wordmark: "Motifect",
    tagline:
      "プレーンテキストのプロンプトから、制作レディな3Dモーションを生成します。",
    videoLabel: "Motifect デモ：テキストプロンプトからモーションへ",
  },
};
